<template>
  <div>
    <Breadtabsheader />
    <div class="dashBox">
      <!-- 顶部 -->
      <div class="dashTop">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="topInfo">
              <div class="infoItem" style="margin-bottom: 10px">
                <div class="infoImg">
                  <img :src="saveurl?saveurl:'@/assets/images/defaultHead.png'">
                  <span class="userNameClass">{{cname?cname:userInfo.username}}</span>
                  <div class="top-badge" v-if="topNumber >= 500"><span>
                    {{topNumber >= 500 && topNumber < 1000 ? 'UP100' : topNumber >=1000 ? 'UP50' : ''}}
                  </span>
                  </div>
                </div>
                <el-button
                    class="infoBtn"
                    size="small"
                    type="primary"
                    v-if="!this.agentCode"
                    @click="bindModifyInfo"
                >修改</el-button>
              </div>
              <el-row v-if="smkx > 0" style="margin-bottom: 20px;display: flex;align-items: baseline">
                <el-col :span="4">
                  <span style="font-weight: 550;font-size: 14px">生命科学领域</span>
                </el-col>
                <el-col :span="14">
                  <el-progress
                      class="progress"
                      :percentage="smkx"
                      :stroke-width="15"
                  >
                  </el-progress>
                </el-col>
                <el-col :span="6">
                  <span style="font-size: 12px;">全年目标:{{smkxTarget}}(万元)</span>
                </el-col>
              </el-row>
              <el-row v-if="ylcx > 0" style="margin-bottom: 20px;display: flex;align-items: baseline">
                <el-col :span="4">
                  <span style="font-weight: 550;font-size: 14px">医疗创新领域</span>
                </el-col>
                <el-col :span="14">
                  <el-progress
                      class="progress"
                      :percentage="ylcx"
                      :stroke-width="15">
                  </el-progress>
                </el-col>
                <el-col :span="6">
                  <span style="font-size: 12px;">全年目标:{{ylcxTarget}}(万元)</span>
                </el-col>
              </el-row>
              <el-table
                  class="infoTable"
                  :data="perTableData"
                  height="225px"
                  :header-cell-style="cellStyle"
                  :cell-style="tdStyle"
                  style="width: 100%;border:none;"
              >
                <el-table-column
                    prop="field"
                    label="领域"
                    width="100"
                >
                  <template slot-scope="scope">
                    <span>{{scope.row.field==1?'生命科学':'医疗创新'}}</span>
                  </template>
                </el-table-column>
                <!--                <el-table-column-->
                <!--                  prop="channel"-->
                <!--                  label="渠道"-->
                <!--                >-->
                <!--                  <template slot-scope="scope">-->
                <!--                    <span style="font-weight: 600">{{scope.row.channel}}</span>-->
                <!--                  </template>-->
                <!--                </el-table-column>-->
                <el-table-column
                    prop="firstQuarterM"
                    label="累计目标"
                >
                  <template slot-scope="scope">
                    <span style="color:#999999;">{{scope.row.firstQuarterM?scope.row.firstQuarterM+'万元':''}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="firstQuarterL"
                    label="累计履约率"
                >
                  <template slot-scope="scope">
                    <span style="color:#999999;">{{scope.row.firstQuarterL}}%</span>
                  </template>
                </el-table-column>
                <!--                <el-table-column-->
                <!--                    prop="firstQuarter"-->
                <!--                    label="累计销额/累计目标"-->
                <!--                >-->
                <!--                  <template slot-scope="scope">-->
                <!--                    <span style="color:#999999;">{{scope.row.firstQuarter}}/{{scope.row.firstQuarterM}}</span>-->
                <!--                  </template>-->
                <!--                </el-table-column>-->
                <el-table-column label="操作" width="60">
                  <template slot-scope="scope">
                    <el-button
                        @click="bindDetailsview(scope.row)"
                        type="text"
                        size="small"
                        style="color:#285ef0;"
                    >
                      查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="topChart">
              <div
                  class="chartbox"
                  ref="chartboxRef"
              ></div>
              <div class="chartBtn">
                <p
                    :class="index==activeIndex?'activeCor':''"
                    v-for="(item,index) in chartsList"
                    :key="index"
                    @click="bindActiveIndex(index,item.region)"
                >{{item.region}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="dashContext">
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="conLeft">
              <div class="leftGrade">
                <div class="gradeTitle">
                  <div class="title">我的等级</div>
                  <p>等级: {{filterLevel(capacityData.totalScore)}}</p>
                </div>
                <div clss="gradeFunnel">
                  <img src="@/assets/images/gradeFunnel2.jpg" alt="" style="position: relative;width: 270px;height: 257px;">
                  <p style="position:absolute;top:124px;left: 142px;color: #666;font-size: 12px">
                      <b style="color: #fff">S类</b>
                      <span style="position: absolute;left: 50px;width: 60px">得分≥80分</span>
                  </p>
                  <p style="position:absolute;top:164px;left: 142px;color: #666;font-size: 12px">
                    <b style="color: #fff">A类</b>
                    <span style="position: absolute;left: 70px;width: 60px">得分≥60分</span>
                  </p>
                  <p style="position:absolute;top:206px;left: 142px;color: #666;font-size: 12px">
                    <b style="color: #fff">B类</b>
                    <span style="position: absolute;left: 90px;width: 60px">得分≥50分</span>
                  </p>
                  <p style="position:absolute;top:246px;left: 142px;color: #666;font-size: 12px">
                    <b style="color: #fff">C类</b>
                    <span style="position: absolute;left: 114px;width: 60px">得分<50分</span>
                  </p>
                </div>
                <!--                <div-->
                <!--                  class="gradeFunnel"-->
                <!--                  ref="gradeRef"-->
                <!--                ></div>-->
              </div>
              <div
                  class="leftGrade"
                  style="margin-top:20px;"
              >
                <div class="gradeTitle">
                  <div class="title">返利兑现</div>
                  <el-button
                      class="infoBtn"
                      size="small"
                      type="primary"
                      @click="goRCTool"
                      style="background: linear-gradient(to right, #5c85f3, #285ef0)"
                  >返利测算工具</el-button>
                  <el-button
                      class="infoBtn"
                      size="small"
                      type="primary"
                      @click="goRCToolBlood"
                      style="margin-left: 8px;background: linear-gradient(to right, #5c85f3, #285ef0)"
                  >返利测算工具-血液</el-button>
                  <!--                   <p @click="goRCTool" style="cursor: pointer">返利测算工具</p>-->
                </div>
                <el-table
                    class="infoTable"
                    :data="creditList"
                    height="225px"
                    :header-cell-style="cellStyle"
                    :cell-style="tdStyle"
                    style="width: 100%;border:none;"
                >
                  <el-table-column
                      prop="zxh"
                      label="流水号"
                      min-width="90"
                      show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                      prop="zjlje"
                      label="应兑"
                      min-width="60"
                      show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#999999;">{{scope.row.zjlje}}</span>
                    </template>
                  </el-table-column>
                  <!--                  <el-table-column
                                      prop="zydje"
                                      label="已兑"
                                      min-width="60"
                                    >
                                      <template slot-scope="scope">
                                        <span style="color:#999999;">{{scope.row.zydje}}</span>
                                      </template>
                                    </el-table-column>-->
                  <el-table-column
                      prop="zwdje"
                      label="未兑"
                      min-width="60"
                      show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#999999;">{{scope.row.zwdje}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="操作"
                      min-width="50"
                  >
                    <template slot-scope="scope">
                      <el-button
                          @click="bindFlCashview(scope.row)"
                          type="text"
                          size="small"
                          style="color:#285ef0;"
                      >
                        查看
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="centerGrade">
              <div
                  class="title"
                  style="margin-bottom:15px;"
              >
                <el-row class="rowClass">
                  <el-col :span="4">
                    <span>能力诊断</span>
                  </el-col>
                  <el-col :span="10">
                    &nbsp;
                  </el-col>
                  <el-col :span="10">
                    <el-form :inline="true"  :model="q" >
                      <el-form-item label="季度"  style="width: 200px;margin-right: 4px;margin-bottom: 0;height: 20px">
                        <el-select v-model="q.quarterStr"  style="width: 120px;height: 20px;top: -0.1rem" :clearable="true"
                                   placeholder="请选择" @change="handleFilter">
                          <el-option label="第一季度" value="1"></el-option>
                          <el-option label="第二季度" value="2"></el-option>
                          <el-option label="第三季度" value="3"></el-option>
                          <el-option label="第四季度" value="4"></el-option>
                        </el-select>

                      </el-form-item>
                    </el-form>
                  </el-col>
                </el-row>
              </div>
              <div class="centerChart">
                <div class="radarLeft">
                  <div class="infoTitle">
                    <p style="font-weight: 600">综合得分</p>
                    <div class="numFs">
                      <span>{{capacityData.totalScore}}</span>
                      <p>分</p>
                    </div>
                  </div>
                  <div
                      class="radarChart"
                      ref="radarRef"
                  ></div>
                </div>
                <div class="radarInfo">
                  <el-tooltip
                      placement="top"
                      effect="light"
                  >
                    <div slot="content">
                      <div class="popText">年度履约率：{{capacityData.xiaoshou.yearL}}
                      </div>
                      <div class="popText">季度履约率：{{capacityData.xiaoshou.quarterL}}
                      </div>
                      <div class="popText">履约率达标个数：{{capacityData.xiaoshou.achieveNum}}
                      </div>
                      <div class="popText">总月数：{{capacityData.xiaoshou.zongMonthNum}}
                      </div>
                      <div class="popText">达标分数：{{capacityData.xiaoshou.standardScore}} 分
                      </div>
                      <div class="popText">满分：{{capacityData.xiaoshou.fullScore}} 分</div>
                      <div class="popText">得分：{{capacityData.xiaoshou.score}} 分</div>
                      <div class="popText">是否达标：{{capacityData.xiaoshou.isStandard?'是':'否'}}
                      </div>
                    </div>
                    <div
                        class="infoTitle"
                        style="cursor: pointer;"
                    >
                      <div class="titleXs">销售收入能力</div>
                      <div class="numXs">
                        <span>{{capacityData.xiaoshou.score}}</span>
                        <p>分</p>
                      </div>
                    </div>
                  </el-tooltip>
                  <div class="infoItem">
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">用户覆盖度：{{capacityData.guanjianuser.topUserCoverage}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.guanjianuser.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.guanjianuser.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.guanjianuser.score}} 分</div>
                        <div class="popText">是否达标：{{capacityData.guanjianuser.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>抓关键</p>
                        <p>用户能力</p>
                        <p class="textMar"><span>{{capacityData.guanjianuser.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">新品履约率：{{capacityData.tupo.newProductPerformance}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.tupo.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.tupo.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.tupo.score}} 分</div>
                        <div class="popText">是否达标：{{capacityData.tupo.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>新品</p>
                        <p>突破能力</p>
                        <p class="textMar"><span>{{capacityData.tupo.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">专业团队能力：{{capacityData.major_eam.userTeamCount}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.major_eam.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.major_eam.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.major_eam.score}} 分</div>
                        <div class="popText">是否达标：{{capacityData.major_eam.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>专业</p>
                        <p>团队能力</p>
                        <p class="textMar"><span>{{capacityData.major_eam.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="infoItem nobor">
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">
                          分销商有效成单个数：{{capacityData.fenxiao_platform.userValidCount}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.fenxiao_platform.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.fenxiao_platform.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.fenxiao_platform.score}} 分</div>
                        <div class="popText">
                          是否达标：{{capacityData.fenxiao_platform.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>分销商</p>
                        <p>平台能力</p>
                        <p class="textMar"><span>{{capacityData.fenxiao_platform.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">
                          场景方案订单用户个数：{{capacityData.changjingfangan.userSceneCount}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.changjingfangan.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.changjingfangan.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.changjingfangan.score}} 分</div>
                        <div class="popText">
                          是否达标：{{capacityData.changjingfangan.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>抓场景</p>
                        <p>方案能力</p>
                        <p class="textMar"><span>{{capacityData.changjingfangan.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                        placement="top"
                        effect="light"
                    >
                      <div slot="content">
                        <div class="popText">
                          漏斗转化率：{{capacityData.loudouzhuanhuan.funnelConversion}}
                        </div>
                        <div class="popText">达标分数：{{capacityData.loudouzhuanhuan.standardScore}} 分
                        </div>
                        <div class="popText">满分：{{capacityData.loudouzhuanhuan.fullScore}} 分</div>
                        <div class="popText">得分：{{capacityData.loudouzhuanhuan.score}} 分</div>
                        <div class="popText">
                          是否达标：{{capacityData.loudouzhuanhuan.isStandard?'是':'否'}}
                        </div>
                      </div>
                      <div class="itemText">
                        <p>漏斗</p>
                        <p>转化能力</p>
                        <p class="textMar"><span>{{capacityData.loudouzhuanhuan.score}}</span>分</p>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="centerOpinion">
                <div
                    class="title"
                    style="border:none;margin-bottom:20px;"
                >实时诊断意见</div>
                <div class="centerConOption">
                  <div
                      class="opinionItem"
                      v-for="(item,index) in opinionList"
                      :key="index"
                  >
                    <div class="itemImgLeft">
                      <img src="@/assets/images/tips.png">
                      <div class="itemText">
                        <span>问题: {{item.gapProblem}}</span>
                        <p>建议: {{item.gapProposal}}</p>
                      </div>
                    </div>
                    <!-- opinionActive -->
                    <!-- <div class="opinionBtn">关差</div> -->
                    <el-tag
                        type="danger"
                        class="opinionBtn"
                        v-if="item.state==0"
                        @click="bindCloseGap(item)"
                        effect="dark"
                    >关差</el-tag>
                    <el-tag
                        type="warning"
                        class="opinionBtn"
                        v-if="item.state==1"
                        @click="bindCloseGap(item)"
                        effect="dark"
                    >关差中</el-tag>
                    <el-tag
                        type="danger"
                        class="opinionBtn"
                        v-if="item.state==2"
                        @click="bindCloseGap(item)"
                        effect="dark"
                    >关差驳回</el-tag>
                    <el-tag
                        type="success"
                        class="opinionBtn"
                        v-if="item.state==3"
                        @click="bindCloseGap(item)"
                        effect="dark"
                    >已关差</el-tag>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="rightTodo">
              <div class="todoTitle">
                <div class="title">待办</div>
                <span
                    style="font-size:12px;color:#285ef0;cursor: pointer;font-weight: 550"
                    @click="bindTodoPage"
                >更多</span>
              </div>
              <div class="todoList">
                <div
                    class="listText"
                    v-for="(item,index) in todoData"
                    :key="index"
                >
                  <div class="listTextLeft">
                    <span
                        class="text1"
                        :title="item.progressName"
                    >{{item.progressName}}</span>
                    <span
                        class="text2"
                        :title="item.cjrname"
                    >{{item.cjrname}}</span>
                    <span
                        class="text3"
                        :title="item.name"
                    >{{item.name}}</span>
                    <!--                    <span class="text4">{{item.begindateStr}}</span>-->
                  </div>
                  <el-tag
                      class="listTextRight"
                      :class="item.status==0?'':'listTextActive'"
                      @click="toShowOrComplate(item)"
                  >
                    {{item.status==0?'去处理':'查看'}}
                  </el-tag>
                </div>
                <div
                    v-if="todoData.length==0"
                    style="text-align: center; margin-top: 40px;color: #6666;font-size:16px;"
                >暂无数据</div>
              </div>
            </div>
            <div class="rightMsg">
              <div class="msgTitle">
                <div class="msgButton">
                  <span
                      :class="msgActiveIndex==0?'msgActive':''"
                      @click="bindMsgCheck(0)"
                  >消息</span>
                  <span
                      :class="msgActiveIndex==1?'msgActive':''"
                      @click="bindMsgCheck(1)"
                  >公告</span>
                </div>
                <span
                    style="font-size:12px;color:#285ef0;cursor: pointer;font-weight: 550"
                    @click="bindMsgPage"
                >更多</span>
              </div>
              <div class="msgItemBox">
                <div
                    class="msgItem"
                    v-for="(item,index) in msgData"
                    :key="index"
                >
                  <p class="itemTitle">
                    <i>{{item.title}}</i>
                    <b
                        v-if="item.topUp=='0'"
                        class="b2"
                    >置顶</b>
                    <b
                        v-if="item.iturgent=='0'"
                        class="b1"
                    >加急</b>
                  </p>
                  <span
                      :title="item.text"
                      v-html="item.text"
                  ></span>
                </div>
              </div>
            </div>
            <div class="feedback">
              <div class="feedbackTitle">
                <div class="title">用户反馈</div>
                <p @click="bindFeedback">去反馈</p>
              </div>
              <div class="msgItemBox msgItemFeeb">
                <div
                    class="msgItem"
                    v-for="(item,index) in feedbackList"
                    :key="index"
                    @click="bindResourceList(item)"
                >
                  <p>{{item.dailyQuestion}}</p>
                  <div
                      class="feedList"
                      v-for="(i,idx) in item.qaDtoList"
                      :key="idx"
                  >
                    <div
                        class="feedItem"
                        v-if="i.repContent"
                    >
                      <div
                          class="itemText"
                          :title="i.repContent"
                      >{{i.repContent}}</div>
                      <div
                          class="itemUser"
                          :title="i.jobGroup+'-'+i.jobUsername"
                      >答复人：{{i.jobGroup}}-{{i.jobUsername}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 用户反馈弹出层 -->
    <el-dialog
        :close-on-click-modal="false"
        @close='closeDialog'
        :visible.sync="newDialog"
        class="h-dialog2"
        width="45%"
    >
      <div
          class="h-dialogImg"
          style="background-size: 100%;"
      >
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>用户反馈</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <div style="padding: 12px;">
          <el-form
              :model="feedForm"
              label-position="right"
              :inline="true"
              label-width="100"
              :rules="formRules"
              ref="feedFormRef"
              class="demo-ruleForm h-formbLine h-formbLine1"
          >
            <el-form-item
                label="客户类型"
                prop="euType"
            >
              <el-input
                  value="经销商"
                  :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="客户名称"
                :clearable="true"
            >
              <el-input
                  v-model="feedForm.euName"
                  :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="区域"
                prop="areaCode"
            >
              <brselect
                  :disabled="newDialogEdit"
                  category="YLRegion"
                  v-model="feedForm.areaCode"
                  :v="feedForm.areaCode"
              ></brselect>
            </el-form-item>

            <el-form-item
                label="链群"
                prop="lianqun"
            >
              <brselect
                  :disabled="newDialogEdit"
                  category="gh_lianqun"
                  v-model="feedForm.lianqun"
                  :v="feedForm.lianqun"
              ></brselect>
            </el-form-item>
            <el-form-item
                label="问题分类"
                prop="problemType"
            >
              <brselect
                  :disabled="newDialogEdit"
                  category="xtwt_type"
                  v-model="feedForm.problemType"
                  :v="feedForm.problemType"
              ></brselect>
            </el-form-item>
            <el-form-item
                label="要求到位时间"
                prop="endDate"
            >
              <el-date-picker
                  :disabled="newDialogEdit"
                  v-model="feedForm.endDate"
                  :picker-options="pickerOptions"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
                label="反馈问题"
                class="h-elformWrap-1"
                style="padding-right:0;"
                prop="dailyQuestion"
            >
              <el-input
                  :disabled="newDialogEdit"
                  v-model="feedForm.dailyQuestion"
                  placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="newDialogEdit" style="margin-bottom: 10px">
          <el-table
              :data="gapTableIndex"
              :border="true"
              style="width: 100%"
          >
            <el-table-column
                label="序号"
                type="index"
                width="50px"
            >
            </el-table-column>
            <el-table-column
                prop="jobGroup"
                label="答复平台"
                min-width="100"
            >
            </el-table-column>
            <el-table-column
                prop="jobUsername"
                label="答复人"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="repContent"
                label="答复信息"
                min-width="100"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="cdate"
                label="创建时间"
                min-width="100"
                show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button
              class="h-btn h-bBtn h-bgwhite"
              @click="closeDialog"
          >取消</el-button>
          <el-button
              v-if="!newDialogEdit"
              class="h-btn h-bBtn h-bgblueQ2"
              :loading="feedBtn"
              @click="bindCommitFeed()"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 关差弹窗 -->
    <el-dialog
        :close-on-click-modal="false"
        @close='closeGapDialog'
        :visible.sync="gapDialog"
        class="h-dialog2"
        width="60%"
    >
      <div
          class="h-dialogImg"
          style="background-size: cover;padding-left: 6.02rem;border-top-left-radius: 6px;"
      >
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>关差</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <div style="padding: 20px 15px;">
          <!-- <div class="gapTitle">关差内容</div> -->
          <el-form
              v-if="gapState==0||gapState==2"
              :model="gapForm"
              label-position="right"
              :inline="true"
              label-width="80"
              :rules="gapRules"
              class="demo-ruleForm h-formbLine h-formbLine1"
          >
            <el-form-item
                label="关差内容"
                class="h-elformWrap-1"
                style="padding-right:0;"
            >
              <el-input
                  v-model="gapForm.gapContent"
                  placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="关差附件"
                class="h-elformWrap-1"
                style="padding-right:0;"
            >
              <!-- :limit="1" -->
              <brupload
                  v-model="fileInfoList"
                  :refid="gapId"
                  reftype="GAP"
                  :showtime="false"
                  uploadflag
                  delflag
                  @filecallback="mfIsUpload"
              >
              </brupload>
            </el-form-item>
          </el-form>
          <div class="gapTitle">关差记录</div>
          <div class="h-table smTableRq ljjtablepaddingsrq">
            <el-table
                :data="gapTable"
                :border="true"
                style="width: 100%"
            >
              <el-table-column
                  label="序号"
                  type="index"
                  width="50px"
              >
              </el-table-column>
              <el-table-column
                  prop="gapType"
                  label="关差类型"
                  min-width="100"
              >
                <template slot-scope="scope">
                  <span>{{filterGapType(scope.row.gapType)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="gapContent"
                  label="关差内容"
                  min-width="100"
                  show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                  prop="userName"
                  label="经销商名称"
                  min-width="100"
                  show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                  prop="state"
                  label="关差状态"
                  min-width="100"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.state==0">关差</span>
                  <span v-if="scope.row.state==1">关差中</span>
                  <span v-if="scope.row.state==2">关差驳回</span>
                  <span v-if="scope.row.state==3">已关差</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  min-width="100"
                  show-overflow-tooltip
              ></el-table-column>

              <el-table-column
                  prop="submitDate"
                  label="提交关差时间"
                  min-width="110"
                  show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                  prop="fileInfoList"
                  label="关差附件"
                  min-width="200"
                  show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <a
                      v-for="(item,index) in scope.row.fileInfoList"
                      :key="index"
                      class="el-upload-list__item-name"
                      style="cursor: pointer;"
                      v-down="item.id"
                  >{{item.name}}</a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button
              class="h-btn h-bBtn h-bgwhite"
              @click="closeGapDialog"
          >取消</el-button>
          <el-button
              v-if="gapState==0||gapState==2"
              class="h-btn h-bBtn h-bgblueQ2"
              @click="bindGapSubmiss()"
              :loading="feedBtn"
          >提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import axios from "axios";
import { cityCode } from "./mapfile/cityCode.js";
import ss from '@/api/SystemService'
export default {
  data () {
    return {
      q: {
        yearStr: new Date().getFullYear(),
        quarterStr:'',
        userCodeOrNmae:this.$route.query.agentCode || this.$store.getters.user.usercode,
        salesregionSell:'',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //生命科学领域履约率
      smkx:0.00,
      smkxTarget:0.00,
      //医疗创新领域履约率
      ylcx:0.00,
      ylcxTarget:0.00,
      //年度签约规模
      topNumber:0,
      feedBtn: false,
      newDialog: false,
      newDialogEdit: false,
      gapDialog: false,
      feedForm: {
        euType: 1,
        euCode: this.$store.getters.user.usercode,
        euName: this.$store.getters.user.username,
        areaCode: '',
        lianqun: '',
        problemType: '',
        endDate: '',
        dailyQuestion: ''
      },
      formRules: {
        // chanceType:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        dailyQuestion: [{ required: true, message: '请输入协同问题', trigger: 'blur' }],
      },
      gapId: '',//
      gapState: '',
      gapForm: {
        gapContent: '',

      },
      fileInfoList: [],
      gapRules: {},
      userInfo: {},
      perTableData: [],//履约信息
      opinionList: [],//诊断意见
      feedbackList: [],//用户反馈
      creditList: [],//信贷
      gapTable: [],//关差记录
      gapTableIndex:[],
      tableData: [],
      chartsList: [],//地图数据
      todoData: [],
      msgData: [],
      optionList: [],
      showFormList: [],
      activeIndex: 0,
      msgActiveIndex: 1,
      myChart: null,
      gradeChart: null,
      radarChart: null,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      cname: '',
      saveurl: '',
      agentCode: '',
      gradeVal: '',//等级
      capacityData: {
        xiaoshou: {},
        guanjianuser: {},
        fenxiao_platform: {},
        tupo: {},
        changjingfangan: {},
        loudouzhuanhuan: {},
        major_eam: {}
      },//能力诊断数据
      areaName: '',//获取当前地图所在区域
    }
  },
  methods: {
    customFormatsmkx(percentage){
      return `生命科学领域 ${percentage}%`;
    },
    customFormatylcx(percentage){
      return `医疗创新领域 ${percentage}%`;
    },
    handleFilter(val){
      console.log(val)
      if (val){
        ss.noticeBoard.getUserSalesAbilityPage(this.q).then(rd => {
          console.log('看看走没走查询', rd.records)
          this.q.total = rd.total;
          if (rd.records.length > 0) {
            let ability = rd.records[0]
            console.log(ability)
            //综合得分
            this.capacityData.totalScore = ability.allScore;
            //销售收入能力
            this.capacityData.xiaoshou.score = ability.xSScore;
            //年度履约率
            this.capacityData.xiaoshou.yearL = ability.xSYearL;
            //季度履约率
            this.capacityData.xiaoshou.quarterL = ability.xSQuarterL;
            //履约率达标个数
            this.capacityData.xiaoshou.achieveNum = ability.xSAchieveNum;
            //是否达标 得分大于等于达标分数
            if (ability.xSScore && ability.xSScore >= this.capacityData.xiaoshou.standardScore) {
              this.capacityData.xiaoshou.isStandard = '是'
            } else {
              this.capacityData.xiaoshou.isStandard = '否'
            }
            /***********************************************************/
            //抓关键用户能力
            this.capacityData.guanjianuser.score = ability.gJScore;
            //用户覆盖度
            this.capacityData.guanjianuser.topUserCoverage = ability.gJTopUserCoverage;
            //是否达标
            if (ability.gJScore && ability.gJScore >= this.capacityData.guanjianuser.standardScore) {
              this.capacityData.guanjianuser.isStandard = '是';
            } else {
              this.capacityData.guanjianuser.isStandard = '否';
            }
            /*****************************************************************/
            //新品突破能力
            this.capacityData.tupo.score = ability.xPScore;
            //新品履约率
            this.capacityData.tupo.newProductPerformance = ability.xPScore;
            //达标分数：{{capacityData.tupo.standardScore}} 分
            //满分：{{capacityData.tupo.fullScore}} 分
            //是否达标
            if (ability.xPScore && ability.xPScore >= this.capacityData.tupo.standardScore) {
              this.capacityData.tupo.isStandard = '是';
            } else {
              this.capacityData.tupo.isStandard = '否';
            }
            /*****************************************************************************/
            //专业团队能力
            this.capacityData.major_eam.score = ability.zYScore;
            //专业团队能力
            this.capacityData.major_eam.userTeamCount = ability.zYPNumDecimal;
            //达标分数：{{capacityData.major_eam.standardScore}} 分
            //满分：{{capacityData.major_eam.fullScore}} 分</div>
            //是否达标
            if (ability.zYScore && ability.zYScore >= this.capacityData.major_eam.standardScore) {
              this.capacityData.major_eam.isStandard = '是'
            } else {
              this.capacityData.major_eam.isStandard = '否'
            }
            /****************************************************************************/
            //分销商平台能力
            this.capacityData.fenxiao_platform.score = ability.fXScore;
            //分销商有效成单个数
            this.capacityData.fenxiao_platform.userValidCount = ability.fXUserValidCount;
            //达标分数：{{capacityData.fenxiao_platform.standardScore}} 分
            //满分：{{capacityData.fenxiao_platform.fullScore}} 分</div>
            //是否达标
            if (ability.fXScore && ability.fXScore >= this.capacityData.fenxiao_platform.standardScore) {
              this.capacityData.fenxiao_platform.isStandard = '是';
            } else {
              this.capacityData.fenxiao_platform.isStandard = '否';
            }
            /****************************************************************************/
            //抓场景方案能力
            this.capacityData.changjingfangan.score = ability.cJScore;
            //场景方案订单用户个数
            this.capacityData.changjingfangan.userSceneCount = ability.cJSceneCount;
            //达标分数：{{capacityData.changjingfangan.standardScore}} 分
            //满分：{{capacityData.changjingfangan.fullScore}} 分</div>
            //是否达标
            if (ability.cJScore && ability.cJScore >= this.capacityData.changjingfangan.standardScore) {
              this.capacityData.changjingfangan.isStandard = '是';
            } else {
              this.capacityData.changjingfangan.isStandard = '否';
            }
            /****************************************************************************/
            //漏斗转化能力
            this.capacityData.loudouzhuanhuan.score = ability.lDScore;
            //漏斗转化率
            this.capacityData.loudouzhuanhuan.funnelConversion = ability.lDFunnelConversion;
            //达标分数：{{capacityData.loudouzhuanhuan.standardScore}} 分
            //满分：{{capacityData.loudouzhuanhuan.fullScore}} 分</div>
            //是否达标
            if (ability.lDScore && ability.lDScore >= this.capacityData.loudouzhuanhuan.standardScore){
              this.capacityData.loudouzhuanhuan.isStandard = '是';
            }else {
              this.capacityData.loudouzhuanhuan.isStandard = '否';
            }
            let indData = [
              { name: "抓关键用户能力", max: this.capacityData.guanjianuser.fullScore },
              { name: "新品突破能力", max: this.capacityData.tupo.fullScore },
              { name: "专业团队能力", max: this.capacityData.major_eam.fullScore },
              { name: "分销商平台能力", max: this.capacityData.fenxiao_platform.fullScore },
              { name: "抓场景方案能力", max: this.capacityData.changjingfangan.fullScore },
              { name: "漏斗转化能力", max: this.capacityData.loudouzhuanhuan.fullScore },
            ]
            let valData = [this.capacityData.guanjianuser.score, this.capacityData.tupo.score, this.capacityData.major_eam.score,
              this.capacityData.fenxiao_platform.score, this.capacityData.changjingfangan.score, this.capacityData.loudouzhuanhuan.score]
            this.radarData(indData, valData)
          } else {
            console.log("无数据");
            //综合得分
            this.capacityData.totalScore = 0;
            //销售收入能力
            this.capacityData.xiaoshou.score = 0;
            //年度履约率
            this.capacityData.xiaoshou.yearL = 0;
            //季度履约率
            this.capacityData.xiaoshou.quarterL = 0;
            //履约率达标个数
            this.capacityData.xiaoshou.achieveNum = 0;
            //是否达标 得分大于等于达标分数
            this.capacityData.xiaoshou.isStandard = '否'
            /***********************************************************/
            //抓关键用户能力
            this.capacityData.guanjianuser.score = 0;
            //用户覆盖度
            this.capacityData.guanjianuser.topUserCoverage = 0;
            //是否达标
            this.capacityData.guanjianuser.isStandard = '否';
            /*****************************************************************/
            //新品突破能力
            this.capacityData.tupo.score = 0;
            //新品履约率
            this.capacityData.tupo.newProductPerformance = 0;
            //达标分数：{{capacityData.tupo.standardScore}} 分
            //满分：{{capacityData.tupo.fullScore}} 分
            //是否达标
            this.capacityData.tupo.isStandard = '否';
            /*****************************************************************************/
            //专业团队能力
            this.capacityData.major_eam.score = 0;
            //专业团队能力
            this.capacityData.major_eam.userTeamCount = 0;
            //达标分数：{{capacityData.major_eam.standardScore}} 分
            //满分：{{capacityData.major_eam.fullScore}} 分</div>
            //是否达标
            this.capacityData.major_eam.isStandard = '否'
            /****************************************************************************/
            //分销商平台能力
            this.capacityData.fenxiao_platform.score = 0;
            //分销商有效成单个数
            this.capacityData.fenxiao_platform.userValidCount = 0;
            //达标分数：{{capacityData.fenxiao_platform.standardScore}} 分
            //满分：{{capacityData.fenxiao_platform.fullScore}} 分</div>
            //是否达标
            this.capacityData.fenxiao_platform.isStandard = '否';
            /****************************************************************************/
            //抓场景方案能力
            this.capacityData.changjingfangan.score = 0;
            //场景方案订单用户个数
            this.capacityData.changjingfangan.userSceneCount = 0;
            //达标分数：{{capacityData.changjingfangan.standardScore}} 分
            //满分：{{capacityData.changjingfangan.fullScore}} 分</div>
            //是否达标
            this.capacityData.changjingfangan.isStandard = '否';
            /****************************************************************************/
            //漏斗转化能力
            this.capacityData.loudouzhuanhuan.score = 0;
            //漏斗转化率
            this.capacityData.loudouzhuanhuan.funnelConversion = 0;
            //达标分数：{{capacityData.loudouzhuanhuan.standardScore}} 分
            //满分：{{capacityData.loudouzhuanhuan.fullScore}} 分</div>
            //是否达标
              this.capacityData.loudouzhuanhuan.isStandard = '否';
            let indData = [
              { name: "抓关键用户能力", max: this.capacityData.guanjianuser.fullScore },
              { name: "新品突破能力", max: this.capacityData.tupo.fullScore },
              { name: "专业团队能力", max: this.capacityData.major_eam.fullScore },
              { name: "分销商平台能力", max: this.capacityData.fenxiao_platform.fullScore },
              { name: "抓场景方案能力", max: this.capacityData.changjingfangan.fullScore },
              { name: "漏斗转化能力", max: this.capacityData.loudouzhuanhuan.fullScore },
            ]
            let valData = [this.capacityData.guanjianuser.score, this.capacityData.tupo.score, this.capacityData.major_eam.score,
              this.capacityData.fenxiao_platform.score, this.capacityData.changjingfangan.score, this.capacityData.loudouzhuanhuan.score]
            this.radarData(indData, valData)
          }
        })
      } else {
        this.getUserSalesAbilityData();
      }
    },
    goRCTool(){  //跳转返利测算工具
      this.$router.push({
        path: '/establish/rebateCalculateTool',
      });
      sessionStorage.setItem("areaName", this.areaName);
    },
    goRCToolBlood(){
      this.$router.push({
        path: '/establish/rebateCalculateToolBlood',
      });
      sessionStorage.setItem("areaName", this.areaName);
    },
    filterLevel (num) {
      if (num < 50) {
        return 'C'
      } else if (num >= 50 && num < 60) {
        return 'B'
      } else if (num >= 60 && num < 80) {
        return 'A'
      } else if (num >= 80) {
        return 'S'
      }
    },
    // 过滤当前能力
    // filterGapType (type) {
    //   if (type == 1) {
    //     return '销售收入能力'
    //   } else if (type == 2) {
    //     return '抓关键用户能力'
    //   } else if (type == 3) {
    //     return '新品突破能力'
    //   } else if (type == 4) {
    //     return '专业团队能力'
    //   } else if (type == 5) {
    //     return '分销商平台能力'
    //   } else if (type == 6) {
    //     return '抓场景方案能力'
    //   } else if (type == 7) {
    //     return '漏斗转化能力'
    //   } else {
    //     return ''
    //   }
    // },
    // 过滤当前能力
    filterGapType (type) {
      if (type == 1) {
        return '销售收入能力'
      } else if (type == 2) {
        return '直面用户能力'
      } else if (type == 3) {
        return '品类均衡能力'
      } else if (type == 4) {
        return '专业化团队能力'
      } else if (type == 5) {
        return '分销商对阵能力'
      } else if (type == 6) {
        return '机会获取能力'
      } else {
        return ''
      }
    },

    // 切换消息及公告
    bindMsgCheck (index) {
      this.msgActiveIndex = index
      this.getMessageData()
    },
    tpylclick (file) {
      window.open('https://oms.haierbiomedical.com/' + file.saveurl, '_blank')
    },
    //上传附件回传
    mfIsUpload (val) {
      console.log('mfIsUpload', val)
      this.fileInfoList = val
    },
    // 选择关差
    bindCloseGap (item) {
      this.gapId = item.id
      this.gapState = item.state
      this.gapForm = {
        ...item,
        gapContent: item.gapContent || ''
      }
      this.getGapByUserCodeAndData()
      this.gapDialog = true
    },
    // 获取关差记录
    getGapByUserCodeAndData () {
      ss.noticeBoard.getGapByUserCodeAndType({
        userCode: this.agentCode ? this.agentCode : this.userInfo.usercode
      }).then(res => {
        this.gapTable = res.msg || []
      })
    },
    // 关闭关差
    closeGapDialog () {
      this.gapForm.gapContent = ''
      this.gapDialog = false
    },
    // 提交关差
    bindGapSubmiss () {
      console.log(this.gapForm)
      if (!this.gapForm.gapContent) {
        this.$msg.msge("请填写关差内容再提交！");
        return false;
      }
      this.feedBtn = true
      ss.noticeBoard.getOpenJxsGap(this.gapForm).then(res => {
        this.feedBtn = false
        this.getJxsGap()
        this.gapDialog = false
      }).finally(() => {
        this.feedBtn = false
      })
    },
    getJxsGap(){
      ss.noticeBoard.getReportFormData({
        agentCode: this.agentCode ? this.agentCode : this.userInfo.usercode
      }).then(res => {
        console.log(res)
        this.opinionList = res.msg.gapList
      })
    },
    // 反馈
    bindFeedback () {
      this.newDialog = true
      this.newDialogEdit = false;
    },
    // 提交反馈
    bindCommitFeed () {
      this.$refs['feedFormRef'].validate((valid) => {
        if (valid) {
          this.feedBtn = true
          ss.noticeBoard.getJxsProblemProblem(this.feedForm).then(res => {
            console.log(res)
            this.$refs.feedFormRef.resetFields()
            this.feedBtn = false
            this.newDialog = false
            this.getReportData()
          }).finally(() => {
            this.feedBtn = false
          })
        } else {
          // this.$msg.msge("请完善协同问题后再提交！");
          return false;
        }
      });

    },
    // 取消反馈弹窗
    closeDialog () {
      this.$refs.feedFormRef.resetFields()
      this.feedForm.euType = 1;
      this.feedForm.areaCode = '';
      this.feedForm.lianqun = '';
      this.feedForm.problemType = '';
      this.feedForm.endDate = '';
      this.feedForm.dailyQuestion = '';
      this.newDialog = false
      this.newDialogEdit = false;
    },
    // 获取首页数据
    getReportData () {
      ss.noticeBoard.getReportFormData({
        agentCode: this.agentCode ? this.agentCode : this.userInfo.usercode
      }).then(res => {
        console.log(res)
        this.perTableData = res.msg.lvYue
        if (null != this.perTableData && this.perTableData.length > 0){
          for (let i = 0; i < this.perTableData.length; i++) {
            this.topNumber += this.perTableData[i].yearM
          }
        }
        //this.opinionList = res.msg.gapList
        if (null != res.msg.lingYu && res.msg.lingYu.length > 0){
          for (let i = 0; i < res.msg.lingYu.length; i++) {
            if ('1' == res.msg.lingYu[i].field){
              this.smkx = res.msg.lingYu[i].yearL
              this.smkxTarget = res.msg.lingYu[i].yearM
            }else if ('2' == res.msg.lingYu[i].field){
              this.ylcx = res.msg.lingYu[i].yearL
              this.ylcxTarget = res.msg.lingYu[i].yearM
            }
          }
        }
        this.feedbackList = res.msg.resourceDemand
        this.creditList = res.msg.flCash
        this.cname = res.msg.headerImage ? res.msg.headerImage.cuname : ''
        if (res.msg.headerImage && res.msg.headerImage.saveurl) {
          ss.UserCare.imgDown(res.msg.headerImage.id).then(data => {
            var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
                byte), ''));
            if (imgbase != 'data:image/png;base64') {
              this.saveurl = imgbase;
            }
          });
        }

        // this.saveurl = res.msg.headerImage ? res.msg.headerImage.saveurl : ''
      })
    },
    // 待办数据
    getTodoData () {
      ss.taskservice.query({
        status: 0,
        pageSize: 10,
        pageNo: 1,
      }).then(rd => {
        if (rd.records.length > 0) {
          this.todoData = rd.records.slice(0, 4);
        } else {
          this.todoData = []
        }
      })
    },
    //消息以及公告
    getMessageData () {
      ss.messageService.query({
        pageSize: 10,
        pageNo: 1,
        announcement: this.msgActiveIndex
      }).then(res => {
        console.log(res)
        if (res.records.length > 0) {
          this.msgData = res.records.slice(0, 3);
        } else {
          this.msgData = []
        }
      })
    },
    // 跳转当前待办信息页面
    toShowOrComplate (r) {
      this.$router.push({ path: r.dburl, query: { taskid: r.id, ywid: r.ywid, instid: r.instid, taskstatus: r.status, f: 1 } })
    },
    // 跳转信贷列表
    bindFlCashview (row) {
      this.$router.push({ path: '/flCashDetail?zxh=' + row.zxh })
    },
    // 跳转反馈列表
    bindResourceList (item) {
      //this.$router.push({ path: '/newResourceList' })
      console.log(item)
      this.feedForm = item;
      this.newDialog = true;
      this.newDialogEdit = true;
      this.gapTableIndex = item.qaDtoList;
    },
    // 履约查看跳转
    bindDetailsview (row) {
      this.$router.push({ path: '/establish/customerLvyueTable2025?agentCode=' + this.agentCode})
    },
    // 跳转待办页面
    bindTodoPage () {
      this.$router.push({ path: '/personal/dealCenter' })
    },
    // 跳转修改个人信息页面
    bindModifyInfo () {
      this.$router.push({ path: '/personal/userin' })
    },
    // 跳转消息以及公告页面
    bindMsgPage () {
      this.$router.push({ path: '/personal/messageCenter' })
    },
    // 选中当前地图
    bindActiveIndex (index) {
      this.activeIndex = index
      this.getSwitchMap()
    },
    // 获取当前地图编码并生成地图
    getMapCityList () {
      ss.noticeBoard.getUserMapData({
        userCode: this.agentCode ? this.agentCode : this.userInfo.usercode
      }).then(res => {
        // console.log(res)
        let mapDataList = res.msg.mapDataList
        this.chartsList = mapDataList
        this.getSwitchMap()
      }).finally(() => {
        // this.feedBtn = false
      })
    },
    getSwitchMap () {
      let mapData = this.chartsList[this.activeIndex].leveMaps
      mapData = mapData.map(item => {
        return {
          name: item.cityName,
          value: Number(item.coverage),
          matchNum: Number(item.matchNum),
          fxs1: item['fxs1.0'],
          fxs2: item['fxs2.0'],
          fxs3: item['fxs3.0'],
          sale: item.saleNum
        }
      })
      mapData = mapData.filter((item)=>item.name!='省直辖县级行政区划')  //过滤一下，地图上渲染不出来这个地区
      let maoName = this.chartsList[this.activeIndex].region
      let adcode = cityCode.find(item => item.name.includes(maoName)).adcode
      // console.log(maoName)
      // console.log(adcode)
      this.initMap(mapData, maoName, Number(adcode))
      this.areaName =  maoName   //获取当前的区域编码

    },
    // 初始化地图数据
    initMap (mapData, name, code) {
      let arr = [110000, 120000, 310000, 500000, 320500, 440300]
      const containsValue = arr.includes(code);
      let jsonUrl = null
      if (containsValue) {
        jsonUrl = `${code}.json`
      } else {
        jsonUrl = `${code}_full.json`
      }
      // 主地图的JSON文件下载
      this.myChart = this.$echarts.init(this.$refs.chartboxRef);
      this.myChart.showLoading({
        text: 'loading',
        color: '#409EFF',
      });
      // let path = `https://geo.datav.aliyun.com/areas_v3/bound/${code}.json`;
      ss.noticeBoard.getMapAreaData({
        urlCode: jsonUrl
      }).then((res) => {
        let msgMap = JSON.parse(res.msg)
        let arr1 = msgMap.features.filter(item1=>!mapData.find(item2=>item2.name == item1.properties.name ))
        if(arr1.length){
          mapData.push({
            name: arr1[0].properties.name,
            value: 0,
            matchNum: 0,
            fxs1: 0,
            fxs2: 0,
            fxs3: 0,
            sale: 0
          })
        }

        this.myChart.hideLoading();
        this.$echarts.registerMap(name, msgMap);
        var option = {
          visualMap: {
            min: 0,
            max: 100000,
            show: !0,
            //   text: ['High', 'Low'],
            // realtime: false,
            // calculable: false,
            left: 0,
            top: 0,
            legend: false,
            seriesIndex: [0],
            pieces: [
              {
                gte: 100,
                label: "100%覆盖",
                color: "#39b4c2" //#a5d48e
              },
              {
                gte: 70,
                lt: 100,
                label: ">70%覆盖",
                color: "#6fcad5" //#758dd0
              },
              {
                gt: 50,
                lte: 70,
                label: "70%>覆盖>50%",
                color: "#97d4db" //#f9d37b
              },
              {
                gt: 0,
                lte: 50,
                label: "<50%覆盖",
                color: "#bae1e5" //#e38686
              },
              {
                lte: 0,
                label: "无覆盖",
                color: "#d1d1d1"
              }
            ],
          },
          tooltip: {
            // trigger: 'item',
            padding: 0,
            enterable: true,
            transitionDuration: 1,
            textStyle: {
              color: '#000',
              decoration: 'none',
            },
            formatter: function (params) {
              return `<div style="width:240px;height:200px;background:#fff;border-radius:3px;padding:10px 20px">
                        <p style="display: flex;justify-content: space-between;align-content: center;margin-bottom: 10px">
                          <span style="font-size: 14px;font-weight: 550">${params.data.name}覆盖率</span>
                          <span style="color:#285ef0;font-weight: 550">${params.data.value}%</span>
                        </p>
                        <div style="width: 100%;display: flex;flex-wrap: wrap">
                           <div style="width:90px;height:70px;border-radius: 3px;background: #edf6ff;margin:0 20px 10px 0;display: flex;flex-direction: column;align-items: center;justify-content: center">
                              <p style="font-size: 16px;font-weight: 550">${params.data.fxs1}</p>
                              <p style="font-size: 14px">分销商1.0</p>
                           </div>
                           <div style="width:90px;height:70px;border-radius: 3px;background: #fff5f0;display: flex;flex-direction: column;align-items: center;justify-content: center">
                              <p style="font-size: 16px;font-weight: 550">${params.data.fxs2}</p>
                              <p style="font-size: 14px">分销商2.0</p>
                           </div>
                           <div style="width:90px;height:70px;border-radius: 3px;background: #eafffb;margin:0 20px 10px 0;display: flex;flex-direction: column;align-items: center;justify-content: center">
                              <p style="font-size: 16px;font-weight: 550">${params.data.fxs3}</p>
                              <p style="font-size: 14px">分销商3.0</p>
                           </div>
                           <div style="width:90px;height:70px;border-radius: 3px;background: #fafff0;display: flex;flex-direction: column;align-items: center;justify-content: center">
                              <p style="font-size: 16px;font-weight: 550">${params.data.sale}</p>
                              <p style="font-size: 14px">业务员个数</p>
                           </div>
                        </div>
                      </div> `

              // var tipHtml = '';
              // tipHtml = '<div style="width:140px;height:160px;background:#fff;border-radius:3px">'
              //   + '<div style="width:100%;height:40px;line-height:40px;border-bottom:2px solid #e9ecee;padding:0 8px;margin-bottom:6px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;">' + '</i>'
              //   + '<span style="margin-left:10px;color:#262626;font-size:15px;">' + params.data.name + '</span>' + '</div>'
              //   + '<div>'
              //   + '<p style="color:#262626;font-size:13px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;margin:0 10px">' + '</i>'
              //   + '覆盖率: ' + '<span>' + params.data.value + '</span>' + '%' + '</p>'
              //   + '<p style="color:#262626;font-size:13px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;margin:0 10px">' + '</i>'
              //   + '分销商1.0: ' + '<span style="margin:0 6px;">' + params.data.fxs1 + '</span></p>'
              //   + '<p style="color:#262626;font-size:13px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;margin:0 10px">' + '</i>'
              //   + '分销商2.0: ' + '<span style="margin:0 6px;">' + params.data.fxs2 + '</span></p>'
              //   + '<p style="color:#262626;font-size:13px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;margin:0 10px">' + '</i>'
              //   + '分销商3.0: ' + '<span style="margin:0 6px;">' + params.data.fxs3 + '</span></p>'
              //   + '<p style="color:#262626;font-size:13px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#285ef0;border-radius:40px;margin:0 10px">' + '</i>'
              //   + '业务员个数: ' + '<span style="margin:0 6px;">' + params.data.sale + '</span></p>'
              //   + '</div>' + '</div>';
              // return tipHtml;



              // if (typeof (params.value)[1] == "undefined") {
              //   return params.name + ' : ' + params.value;
              // } else {
              //   return params.name + ' : ' + params.value[1];
              // }
            }
          },// 配置提示框，有这个配置项即可
          series: [
            {
              name: name,
              type: 'map',
              mapType: name,
              layoutCenter: ["50%", "50%"], //设置后left/right/top/bottom等属性无效
              layoutSize: "71%",
              roam: false, //开启鼠标缩放
              // geoIndex: 15,
              aspectScale: 1.3, //地图长度比
              zoom: 1.8,
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#262626',
                    fontWeight: 600,
                    fontSize: 12, //字体
                    textBorderColor: '#fff',
                    textBorderType: 'solid',
                    textBorderWidth: 2,
                    lineHeight: 16,
                  },
                  formatter: (value) => {
                    return value.data.matchNum && value.data.matchNum > 0 ? value.data.matchNum + '\n' + value.data.name : value.data.name
                  }
                },
              },

              itemStyle: {
                normal: {
                  areaColor: "#B2CAE0",  //1c84f4
                  borderWidth: 1,  //0.2
                  borderColor: '#fff', //线   //1c84f4
                  shadowColor: '#092f8f', //外发光  //fff
                  shadowBlur: 0   //5
                  // shadowBlur: 20
                },
                emphasis: {
                  label: {
                    show: true,
                    color: '#262626'
                  },
                  // areaColor: '#0a2dae', //悬浮区背景
                  // areaColor: 'rgb(0,143,217)', //悬浮区背景 //rgb(86,111,206)
                  areaColor: {
                    // 使用渐变色
                    type: 'linear', // 线性渐变
                    x: 0, // 渐变方向的控制点x坐标
                    y: 0, // 渐变方向的控制点y坐标
                    x2: 0, // 渐变结束点的x坐标
                    y2: 1, // 渐变结束点的y坐标
                    colorStops: [{
                      offset: 0, color: '#0082cd' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#38b2f3' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                  }
                }
              },
              data: mapData
            },
          ],
        };
        this.myChart.setOption(option);
        // 点击省份子区域的时候可以切换到省份地图
        this.myChart.on("click", (chinaParam) => {
          console.log(chinaParam)
          this.$router.push({
            path: '/homeBoard/cityDetails',
            query: {
              agentCode: this.agentCode ? this.agentCode : this.userInfo.usercode,
              cityName: chinaParam.data.name,
              seriesName: chinaParam.seriesName,
            }
          })
        });
      });
      window.onresize = function () {
        if (this.myChart) this.myChart.resize();
      };
    },
    // 能力诊断相关数据
    getUserSalesAbilityData () {
      ss.noticeBoard.getUserSalesAbility({
        userCode: this.agentCode ? this.agentCode : this.userInfo.usercode,
        yearStr: null == this.q.quarterStr || '' == this.q.quarterStr ? null :new Date().getFullYear(),
        quarterStr:this.q.quarterStr
      }).then(res => {
        console.log(res)
        let resData = res.msg
        this.capacityData = resData
        this.opinionList = res.msg.gapList
        let indData = [
          { name: "抓关键用户能力", max: resData.guanjianuser.fullScore },
          { name: "新品突破能力", max: resData.tupo.fullScore },
          { name: "专业团队能力", max: resData.major_eam.fullScore },
          { name: "分销商平台能力", max: resData.fenxiao_platform.fullScore },
          { name: "抓场景方案能力", max: resData.changjingfangan.fullScore },
          { name: "漏斗转化能力", max: resData.loudouzhuanhuan.fullScore },
        ]
        let valData = [resData.guanjianuser.score, resData.tupo.score, resData.major_eam.score, resData.fenxiao_platform.score, resData.changjingfangan.score, resData.loudouzhuanhuan.score]
        this.radarData(indData, valData)
      })
    },
    // 能力诊断
    radarData (indData, valData) {
      this.radarChart = this.$echarts.init(this.$refs.radarRef);
      let option = {
        radar: {
          center: ["50%", "50%"],
          radius: 60,
          // shape: 'circle',
          splitArea: {
            areaStyle: {
              color: ["#fff", "#fff", "#fff", "#fff"],
              shadowColor: "rgba(0, 100, 0, 0.3)",
            },
          },
          name: {
            textStyle: {
              color: '#666666',
              fontSize: 12,
              textAlign: 'left'
            },
            formatter: function (value) {
              if (value != '抓关键用户能力' && value != '分销商平台能力') {
                let list = value.split("");
                let result = "";
                if (list.length > 6) {
                  result = value.slice(0, 3);
                  if (value.length > 3) {
                    result += '\n' + value.slice(3);
                  }
                } else {
                  result = value.slice(0, 2);
                  result += '       \n' + value.slice(2);
                }
                return result;
              } else {
                return value
              }
            }
          },

          indicator: indData,
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: valData,
                name: "数据",
                itemStyle: {
                  normal: {
                    color: "rgba(5, 128, 242, 0.8)",
                  },
                },
                areaStyle: {
                  normal: {
                    color: "#3039EF",
                  },
                },
              },
            ],
          },
        ],
      };
      this.radarChart.setOption(option);
      window.onresize = function () {
        if (this.radarChart) this.radarChart.resize();
      };
    },
    // 我的等级
    gradeData () {
      this.gradeChart = this.$echarts.init(this.$refs.gradeRef);
      let option = {

        color: [
          "rgb(41,182,203)",
          "rgb(52,195,242)",
          "rgb(52,146,242)",
          "rgb(86,111,206)",
        ],
        series: [
          {
            name: "占比",
            type: "funnel",
            // left: "center",
            // left: "10%",
            // top: '3%',
            x: '10%',
            y: 10,
            y2: 10,
            width: "60%",
            height: '90%',
            min: 100,
            max: 0,
            gap: 5,
            data: [
              { value: 100, name: "S类" },
              { value: 75, name: "A类" },
              { value: 50, name: "B类" },
              { value: 25, name: "C类" },
            ],
            label: {
              normal: {
                formatter: function (params) {
                  return params.name;
                },
                position: "center",
                textStyle: {
                  color: "#fff",
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 0,
                // shadowBlur: 30,
                shadowOffsetX: 0,
                // shadowOffsetY: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
          {
            name: "占比",
            type: "funnel",
            // left: "center",
            // left: "10%",
            // top: '3%',
            x: '10%',
            y: 10,
            y2: 10,
            width: "60%",
            height: '90%',
            min: 100,
            max: 0,
            // minSize: "0%",
            // maxSize: "90%",
            gap: 5,
            data: [
              { value: 100, name: "得分≥80分" },
              { value: 75, name: "得分≥60分" },
              { value: 50, name: "得分≥50分" },
              { value: 25, name: "得分＜50分" },
            ],
            label: {
              normal: {
                formatter: function (params) {
                  return params.name;
                },

                textStyle: {
                  fontSize: 12,
                  color: '#262626'
                },
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 0,
                shadowBlur: 30,
                shadowOffsetX: 0,
                shadowOffsetY: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },


        ],
      };
      this.gradeChart.setOption(option);
      window.onresize = function () {
        if (this.gradeChart) this.gradeChart.resize();
      };
    },
    cellStyle () {
      return { backgroundColor: '#fff !important', color: '#262626', fontWeight: 'normal' }
    },
    tdStyle () {
      return { fontSize: '13px', color: '#262626', height: '60px' }
    },
  },
  created () {
    this.agentCode = this.$route.query.agentCode || ''
    this.userInfo = this.$store.getters.user
    const date = new Date();
    const month = date.getMonth() + 1; // 获取月份，月份是从0开始的，所以需要+1
    console.log(Math.ceil(month / 3));
    let a = Math.ceil(month / 3);
    if (1 != a){
      this.q.quarterStr = (Math.ceil(month / 3) - 1).toString()
    }
    this.getTodoData()
    this.getMessageData()
    this.getReportData()
  },
  mounted () {
    this.$nextTick(() => {
      // this.gradeData()
      this.getMapCityList();
      this.getUserSalesAbilityData()
    });
  }
}
</script>

<style lang="scss" scoped>
::v-deep .h-formbLine .el-form-item__label {
  width: 140px;
}
::v-deep .h-formbLine .el-form-item__content {
  width: 250px;
}
::v-deep .h-elformWrap-1 .el-form-item__content {
  width: 78%;
}
.dashBox {
  padding: 35px 20px 0;
  .dashTop {
    .topInfo {
      padding: 20px;
      background: #fff;
      .infoItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .infoImg {
          display: flex;
          align-items: center;
          img {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            border-radius: 50%;
          }
          .userNameClass{
            font-weight: bold;
            font-size: 18px;
          }
        }
        .infoBtn {
          border: none;
          width: 80px;
          background: linear-gradient(to right, #5c85f3, #285ef0);
        }
      }
    }
    .topChart {
      padding: 20px;
      position: relative;
      .chartbox {
        width: 100%;
        height: 350px;  //335px
        // background: #ccc;
      }
      .chartBtn {
        position: absolute;
        right: 15px;
        top: 15px;
        z-index: 100;
        p {
          padding: 4px 18px;
          background: #ecf5ff;
          box-sizing: border-box;
          margin-bottom: 15px;
          border-radius: 2px;
          color: #409eff;
          font-size: 14px;
          cursor: pointer;
        }
        .activeCor {
          background: #285ef0;
          color: #fff;
        }
      }
    }
  }
  .dashContext {
    margin-top: 20px;
    .leftGrade {
      padding: 20px;
      background: #fff;
      .gradeTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        p {
          font-weight: bold;
          color: #285ef0;
        }
      }
      .gradeFunnel {
        width: 100%;
        height: 260px;
      }
    }
    .centerGrade {
      padding: 20px;
      background: #fff;
      .rowClass{
        ::v-deep .el-form-item__label{
          padding-right: 4px;
          line-height: 0;
        }
        ::v-deep .el-input__inner{
          height: 30px;
          line-height: 0;
        }
      }
      .centerChart {
        display: flex;
        .radarLeft {
          width: 54%;
          .radarChart {
            width: 100%;
            height: 314px;
          }
        }
        .radarInfo {
          flex: 1;
          padding: 20px 20px 0 20px;
          //background: #f5f7f9;
          background: linear-gradient(to bottom, #f6f8fa, #fff);// 背景渐变
          border: 1px solid #f5f7f9; //#e9ecee
          margin-bottom: 32px;

          .infoItem {
            padding: 32px 0;
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #4e4b4b;  //#666
            border-bottom: 1px solid #e9ecee;
            .itemText {
              cursor: pointer;
            }
            .textMar {
              margin-top: 20px;
            }
            span {
              margin-right: 8px;
              color: #285ef0;
              font-weight: 600;
            }
          }
          .nobor {
            border-bottom: none;
          }
        }
        .infoTitle {
          display: flex;
          align-items: baseline;
          // justify-content: space-between;
          // padding: 0 20px;
          .titleXs{
            font-size: 13px;   //14px
            color: #4e4b4b; //#666
            //display: flex;
            //flex-direction: column;
          }
          p {
            font-size: 16px;
            color: #666666;
          }
          .numFs,.numXs {
            margin-left: 40px;
            display: flex;
            align-items: baseline;
            padding-right: 10px;
            span {
              font-size: 22px;
              color: #285ef0;
              font-weight: 600;
            }
          }
          .numXs{
            margin-left: 18px; // 20px
            padding-right: 0;
            span {
              font-size: 18px;
              color: #285ef0;
            }
          }
        }
      }
    }
    .centerOpinion {
      margin-top: 20px;
      .centerConOption {
        height: 178px;
        overflow-y: auto;
      }
      .opinionItem {
        padding: 14px 10px;  //10px
        //background: #e9ecee;
        background: linear-gradient(to bottom, #f5f7f9, #fff); //渐变背景
        border: 1px solid #f5f7f9; //e7ecef
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px; //5px
        .itemImgLeft {
          display: flex;
          align-items: center;
          font-size: 12px;
          img {
            width: 34px;
            height: 34px;
          }
          .itemText {
            margin-left: 10px;
            span {
              color: #544e4e; //#666
              display: block;
              margin-bottom: 6px; // 5px
            }
            p{
              font-weight: 550;
            }
          }
        }
        .opinionBtn {
          border-radius: 0;
          height: 25px;
          line-height: 25px;
          cursor: pointer;
          // width: 60px;
          // padding: 4px 0;
          // border-radius: 2px;
          // font-size: 12px;
          // color: #fff;
          // text-align: center;
          // background: #ea5c68;
          // cursor: pointer;
        }
        .opinionActive {
          background: #a4da89;
        }
      }
    }
    .rightTodo {
      padding: 20px 20px 0 20px;
      background: #fff;
      .todoTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .todoList {
        height: 199px;
        .listText {
          padding: 10px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          border-bottom: 1px solid #f1f1f1;
          .listTextLeft {
            width: 80%;
            display: flex;
            align-items: center;
            .text1 {
              background-color: #d3e4ff;
              color: #2a80e7;
              border-radius: 20px;
              width: 30%;
              padding: 4px 8px;
            }
            .text2 {
              background-color: #eee;
              // color: #2a80e7;
              width: 30%;
              padding: 4px 8px;
              margin-left: 10px;
            }
            .text3 {
              // color: #2a80e7;
              width: 30%;
              margin-left: 10px;
            }
            .text4 {
              color: #c0c0c0;
              margin-left: 10px;
            }
            span {
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .listTextRight {
            border-color: #2a80e7;
            color: #2a80e7;
            height: 25px;
            line-height: 25px;
            cursor: pointer;
            font-size: 12px;
          }
          .listTextActive {
            border-color: #4bae51;
            color: #4bae51;
          }
        }
      }
    }
    .rightMsg {
      padding: 15px 20px 8px;
      background: #fff;
      margin-top: 20px;
      .msgTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px; //8px
      }
      .msgButton {
        display: flex;
        span {
          padding: 6px 12px;
          background: #ecf5ff;
          //color: #409eff;
          color: #285ef0;
          margin-right: 10px;
          cursor: pointer;
          font-weight: 560;
        }
        .msgActive {
          color: #fff;
          background: #285ef0;
        }
      }

      // .msgItem {
      //   margin-top: 15px;
      //   font-size: 12px;
      //   p {
      //     font-weight: bold;
      //   }
      // }
    }
    .feedback {
      padding: 15px 20px 10px;
      background: #fff;
      margin-top: 20px;
      .feedbackTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;  //8px
        p {
          width: 60px;
          padding: 2px 0;
          font-size: 12px;
          border: 1px solid #285ef0;
          color: #285ef0;
          text-align: center;
          border-radius: 20px;
          cursor: pointer;
          font-weight: 550;
        }
      }
    }
    .msgItemBox {
      height: 131px; //135px
      overflow-y: auto;
    }
    .msgItemFeeb {
      height: 120px; //125px
    }
    .msgItem {
      margin-bottom: 6px;  //5px
      font-size: 12px;
      cursor: pointer;
      p {
        font-weight: bold;
      }
      .itemTitle {
        display: flex;
        align-items: center;
        i {
          font-style: normal;
        }
        b {
          font-weight: normal;
          padding: 1px 4px;
          border: 1px solid #ccc;
          border-radius: 3px;
          margin-left: 8px;
        }
        .b1 {
          background-color: #f56c6c;
          border-color: #f56c6c;
          color: #fff;
        }
        .b2 {
          background-color: #e6a23c;
          border-color: #e6a23c;
          color: #fff;
        }
      }
      span {
        width: 100%;
        height: 20px;
        line-height: 20px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .feedList {
        width: 100%;
        .feedItem {
          width: 100%;
          height: 20px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .itemText {
            width: 60%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .itemUser {
            width: 35%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // text-align: right;
          }
        }
      }
    }
    .title {
      padding-left: 8px;
      border-left: 4px solid #285ef0;
      color: #666666;
      font-size: 16px;
      font-weight: 550;
    }
  }
  ::v-deep .el-table tbody td:first-child {
    border-left: none;
  }
  ::v-deep .el-table tbody td,
  .el-table tbody .el-table__cell {
    border-right: none;
  }
  ::v-deep .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: none;
  }
  ::v-deep ::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    background-color: #ebeef5;
  }
  ::v-deep ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #ebeef5;
  }
  ::v-deep ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    background: #ebeef5;
  }
  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden !important;
  }
  ::v-deep .el-table {
    // .el-table__body-wrapper {
    //   &::-webkit-scrollbar {
    //     // 整个滚动条
    //     width: 3px; // 纵向滚动条的宽度
    //     background-color: #ebeef5;
    //     // border: none;
    //   }
    //   ::-webkit-scrollbar-thumb {
    //     box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    //     -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    //     background-color: #ccc;
    //   }
    //   &::-webkit-scrollbar-track {
    //     background: rgba(255, 255, 255, 1);
    //     border-radius: 3px;
    //     border: none;
    //     // 滚动条轨道
    //   }
    // }

    // --------------------隐藏table gutter列和内容区右侧的空白

    th.gutter {
      display: none !important;
      width: 0 !important;
    }

    colgroup col[name='gutter'] {
      display: none;
      width: 0;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}
.gapTitle {
  font-size: 18px;
  color: #262626;
  font-weight: bold;
  padding-left: 5px;
  margin-bottom: 10px;
}
.popText {
  line-height: 20px;
}
.progress-gradient {
  height: 30px;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-image: linear-gradient(90deg,#a0cded 0%,#cdaeed 100%);
}
.progress{
  ::v-deep .el-progress-bar{
    width: 260px; // 330px
    margin-left: 5px;
  }
  ::v-deep .el-progress-bar__outer{
    background-color: rgb(235, 238, 245); //#000
  }
  ::v-deep .el-progress-bar__inner{
    background:linear-gradient(to right, #4dbd74, #fdda51, #f36d3e);
  }
  ::v-deep .el-progress__text{
    font-size: 12px !important;
  }
}
.top-badge {
  font-size: 7px;
  background-color: gold;
  display: inline-block;
  width: 25px;
  height: 10px;
  color: #000;
  text-align: center;
  line-height: 10px;
  margin-left: 5px;
  margin-right: 5px;
}
</style>